module.exports = ".mat-form-field {\n  width: 150px; }\n"